import React from "react";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import StandardTable, {StandardColumnsType} from "../../../../components/StandardTable";
import {Button, Divider, Popconfirm, Space, Tag} from "antd";
import *  as api from "../../../../apis/sysPosition";
import useAntTable from "../../../../utils/useAntTable";
import ModifyModal from "./modifyModal";
import useFormModal from "../../../../utils/useFormModal";


function SysPosition(props: { type: number }) {

    const {type} = props
    const {tableProps, form, search, refresh} = useAntTable(api.getPositions(type), {
        defaultParams: {status: true},
    })

    const {modalProps, setVisible} = useFormModal({
        onRequest: api.modifyPosition,
        onOk: () => {
            refresh()
            setVisible(false)
        }
    })

    const columns: StandardColumnsType = [
        {
            dataIndex: 'name',
            title: '职位',
            search: true,
        },
        {
            dataIndex: 'user',
            title: '用户',
            search: true
        },
        {
            dataIndex: 'userName',
            title: '用户名',
            search: true
        },
        {
            dataIndex: 'status',
            title: '状态',
            render: value => value ? <Tag color="green">已启用</Tag> : <Tag color="red">已停用</Tag>,
            search: {
                valueType: 'select',
                valueInitial: true,
                valueEnum: [
                    {text: '启用', value: true},
                    {text: '停用', value: false},
                ],
            },
        },
        {
            dataIndex: 'operations',
            title: '操作',
            render: (_, record) => (
                <span>
                    <a onClick={() => setVisible(true, record)}>编辑</a>
                    <Divider type={'vertical'}/>
                    <Popconfirm title={'是否确认删除'}>
                        <a>删除</a>
                    </Popconfirm>
                </span>
            )
        }
    ]

    return (
        <PageHeaderLayout>
            <StandardTable rowKey={'id'} columns={columns} form={form} search={search} {...tableProps} toolbar={(
                <Space>
                    <Button type={"primary"} onClick={() => setVisible(true, {type, status: true})}>新增</Button>
                </Space>
            )}/>
            <ModifyModal {...modalProps} />
        </PageHeaderLayout>
    )
}

export default SysPosition
